export function getNotifications(
    requestor: { get: (...args: any[]) => Promise<string | string[]> },
    portalType: string,
) {
    return requestor.get(`/notifications?portal=${portalType}`);
}
